import FlexBox from '@/atomic-components/FlexBox';

import { Box, Skeleton } from '@mui/material';

function BuyRentSkeleton() {
	return (
		<Box sx={{ overflow: 'hidden' }}>
			<FlexBox direction='column' justifyContent='center' alignItems='center'>
				<Skeleton variant='text' width={320} height={90} />
				<FlexBox
					sx={{ width: '100%', mt: '12px', mb: '32px' }}
					justifyContent='space-between'
				>
					{[1, 2, 3, 4, 5, 6, 7].map((d) => {
						return (
							<Box key={d}>
								<Skeleton variant='rounded' width={100} height={56} />
								<Skeleton width={100} height={32} sx={{ mt: '8px' }} />
							</Box>
						);
					})}
				</FlexBox>
			</FlexBox>
			<FlexBox sx={{ mb: '20px' }}>
				<Skeleton
					variant='rectangular'
					width={597}
					height={285}
					sx={{ margin: '0 20px 0 0' }}
				/>
				<Skeleton
					variant='rectangular'
					width={597}
					height={285}
					sx={{ margin: '0 20px 0 0' }}
				/>
				<Skeleton
					variant='rectangular'
					width={200}
					height={285}
					sx={{ margin: '0 20px 0 0' }}
				/>
			</FlexBox>
			<Box>
				<FlexBox sx={{ justifyContent: 'space-between', width: '100%' }}>
					<Skeleton variant='text' width={120} height={30} />
					<Skeleton variant='text' width={120} height={30} />
				</FlexBox>
				<FlexBox
					justifyContent={'start'}
					sx={{ overflow: 'scroll', margin: '10px 0', width: '100%' }}
				>
					<Skeleton
						variant='rectangular'
						width={310}
						height={120}
						sx={{ margin: '8px 16px 0 0' }}
					/>
					<Skeleton
						variant='rectangular'
						width={310}
						height={120}
						sx={{ margin: '8px 16px' }}
					/>
					<Skeleton
						variant='rectangular'
						width={310}
						height={120}
						sx={{ margin: '8px 16px' }}
					/>
					<Skeleton
						variant='rectangular'
						width={310}
						height={120}
						sx={{ margin: '8px 16px' }}
					/>
				</FlexBox>
			</Box>

			<Box sx={{ overflow: 'scroll' }}>
				<FlexBox sx={{ justifyContent: 'space-between', width: '100%' }}>
					<Skeleton variant='text' width={120} height={30} />
					<Skeleton variant='text' width={120} height={30} />
				</FlexBox>
				<FlexBox justifyContent={'start'} sx={{ margin: '10px 0' }}>
					<Skeleton
						variant='rectangular'
						width={280}
						height={120}
						sx={{ margin: '0 10px 0 0' }}
					/>
					<Skeleton
						variant='rectangular'
						width={280}
						height={120}
						sx={{ margin: '0 10px' }}
					/>
					<Skeleton
						variant='rectangular'
						width={280}
						height={120}
						sx={{ margin: '0 10px' }}
					/>
					<Skeleton
						variant='rectangular'
						width={280}
						height={120}
						sx={{ margin: '0 10px' }}
					/>
				</FlexBox>
			</Box>
			<Box sx={{ overflow: 'scroll' }}>
				<FlexBox sx={{ justifyContent: 'space-between', width: '100%' }}>
					<Skeleton variant='text' width={120} height={30} />
					<Skeleton variant='text' width={120} height={30} />
				</FlexBox>
				<FlexBox justifyContent={'start'} sx={{ margin: '10px 0' }}>
					<Skeleton
						variant='rectangular'
						width={300}
						height={120}
						sx={{ margin: '0 10px 0 0' }}
					/>
					<Skeleton
						variant='rectangular'
						width={300}
						height={120}
						sx={{ margin: '0 10px' }}
					/>
					<Skeleton
						variant='rectangular'
						width={300}
						height={120}
						sx={{ margin: '0 10px' }}
					/>
					<Skeleton
						variant='rectangular'
						width={300}
						height={120}
						sx={{ margin: '0 10px' }}
					/>
				</FlexBox>
			</Box>
		</Box>
	);
}

export default BuyRentSkeleton;
